import http from "./http-common"

export interface ChangePasswordBody {
  currentPassword: string
  newPassword: string
}

export const changePassword = (idUser: number, body: ChangePasswordBody) =>
  http.put(`/user/${idUser}/password`, body)
